import React, { useState } from 'react';
import { Search, Calendar, Clock, User, ChevronRight, TrendingUp, Mail, ArrowRight, Bookmark, Share2, Eye, Heart, MapPin, Car, Shield, Star, DollarSign, Clock4, Users, Phone, MessageCircle } from 'lucide-react';
import BlogImages from '../Assets/14-cities-mailer-for-blog11.png'
const BlogPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [isBookmarked, setIsBookmarked] = useState({});

  const blogPosts = [
    {
      id: 1,
      title: "10 Essential Safety Tips Every Cab Rider Should Know",
      excerpt: "Learn proven safety strategies to ensure your security during every cab ride, from verifying driver credentials to sharing your location.",
      content: "Safety should always be your top priority when using cab services...",
      category: "safety",
      author: "Shamsudeen",
      authorRole: "Safety Expert",
      date: "2024-01-15",
      readTime: "5 min",
      views: "12.5K",
      likes: 342,
      image: "https://media.cnn.com/api/v1/images/stellar/prod/130705131245-nyc-taxi-driver.jpg?q=w_1110,c_fill",
      authorImage: "https://media.istockphoto.com/id/1292644184/photo/smiling-young-man-outdoors-in-the-city.jpg?s=612x612&w=0&k=20&c=XOW0uqH_Bb56lyIKxO2dtynjSXfG126El5Z2mKcpjvI=",
      featured: true,
      trending: true,
      premium: false
    },
    {
      id: 2,
      title: "Smart Ways to Save Money on Your Daily Commute",
      excerpt: "Cut your transportation costs by up to 40% with these proven money-saving strategies and insider tips for cab bookings.",
      content: "Daily commuting expenses can add up quickly...",
      category: "tips",
      author: "Harshath Khan",
      authorRole: "Finance Advisor",
      date: "2024-01-12",
      readTime: "4 min",
      views: "8.3K",
      likes: 289,
      image: "https://oraybooking.com/newassets/images/services/one-way-cab-booking-service.webp",
      authorImage: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRp6HimeVWg3mMTl4UEJPqMMebDQ0RNF0M9Kg&s",
      featured: true,
      trending: false,
      premium: false
    },
    {
      id: 3,
      title: "The Future of Urban Transportation: 2024 & Beyond",
      excerpt: "Explore how AI, electric vehicles, and smart city technology are revolutionizing cab services and urban mobility.",
      content: "From electric vehicles to AI-powered routing...",
      category: "innovation",
      author: "Dr. Emily Roberts",
      authorRole: "Urban Mobility Researcher",
      date: "2024-01-10",
      readTime: "6 min",
      views: "15.2K",
      likes: 521,
      image: "https://images.unsplash.com/photo-1485463611174-f302f6a5c1c9?w=800&q=80",
      authorImage: "https://img.freepik.com/free-photo/waist-up-portrait-handsome-serious-unshaven-male-keeps-hands-together-dressed-dark-blue-shirt-has-talk-with-interlocutor-stands-against-white-wall-self-confident-man-freelancer_273609-16320.jpg?semt=ais_se_enriched&w=740&q=80",
      featured: false,
      trending: true,
      premium: true
    },
    {
      id: 4,
      title: "Understanding Cab Fare Structures: A Complete Guide",
      excerpt: "Everything you need to know about how cab pricing works, surge pricing, and getting the best value for your money.",
      category: "education",
      author: "David Wilson",
      authorRole: "Transportation Analyst",
      date: "2024-01-08",
      readTime: "3 min",
      views: "6.7K",
      likes: 198,
      image: "https://images.unsplash.com/photo-1601933470096-0e34634ffcde?w=800&q=80",
      authorImage: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&q=80",
      featured: false,
      trending: false,
      premium: false
    },
    {
      id: 5,
      title: "Peak Hours Decoded: Best Times to Book Your Ride",
      excerpt: "Optimize your travel schedule and save time and money by knowing exactly when to book your cab rides.",
      category: "tips",
      author: "Lisa Zhang",
      authorRole: "Data Scientist",
      date: "2024-01-05",
      readTime: "4 min",
      views: "9.1K",
      likes: 267,
      image: "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=800&q=80",
      authorImage: "https://images.unsplash.com/photo-1544725176-7c40e5a71c5e?w=150&q=80",
      featured: false,
      trending: true,
      premium: false
    },
    {
      id: 6,
      title: "Going Green: Our Commitment to Sustainable Transportation",
      excerpt: "Learn about our eco-friendly initiatives and how we're reducing carbon footprint one ride at a time.",
      category: "sustainability",
      author: "Green Team",
      authorRole: "Sustainability Lead",
      date: "2024-01-18",
      readTime: "5 min",
      views: "7.8K",
      likes: 312,
      image: "https://images.unsplash.com/photo-1593941707882-a5bba14938c7?w=800&q=80",
      authorImage: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&q=80",
      featured: false,
      trending: false,
      premium: true
    }
  ];

  const categories = [
    { id: 'all', name: 'All Topics', icon: '📚', color: 'from-blue-600 to-cyan-600', count: blogPosts.length },
    { id: 'safety', name: 'Safety', icon: '🛡️', color: 'from-green-600 to-green-600', count: blogPosts.filter(p => p.category === 'safety').length },
    { id: 'tips', name: 'Tips & Tricks', icon: '💡', color: 'from-amber-600 to-orange-600', count: blogPosts.filter(p => p.category === 'tips').length },
    { id: 'innovation', name: 'Innovation', icon: '🚀', color: 'from-purple-600 to-indigo-600', count: blogPosts.filter(p => p.category === 'innovation').length },
    { id: 'education', name: 'Education', icon: '📖', color: 'from-blue-600 to-indigo-600', count: blogPosts.filter(p => p.category === 'education').length },
    { id: 'sustainability', name: 'Sustainability', icon: '🌱', color: 'from-green-500 to-teal-600', count: blogPosts.filter(p => p.category === 'sustainability').length }
  ];

  const featuredPosts = blogPosts.filter(post => post.featured);
  const trendingPosts = blogPosts.filter(post => post.trending);
  const regularPosts = blogPosts.filter(post => !post.featured);
  
  const filteredPosts = selectedCategory === 'all' 
    ? regularPosts 
    : regularPosts.filter(post => post.category === selectedCategory);

  const toggleBookmark = (postId) => {
    setIsBookmarked(prev => ({
      ...prev,
      [postId]: !prev[postId]
    }));
  };

  const getCategoryData = (categoryId) => {
    return categories.find(c => c.id === categoryId);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50/20">
      
<section className="relative bg-gradient-to-br from-yellow-50 via-yellow-200 to-orange-50 text-black overflow-hidden">
  <div className="absolute inset-0">
    <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?w=1920&q=80')] bg-cover bg-center opacity-20"></div>
    <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 via-transparent to-indigo-600/20"></div>
  </div>
  
  <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
    <div className="grid lg:grid-cols-2 gap-12 items-center">
      {/* LEFT SIDE - UNCHANGED */}
      <div className="relative">
        <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
          Ride Smarter,
          <span className="block bg-gradient-to-r from-yellow-400 via-yellow-400 to-yellow-400 bg-clip-text text-transparent">
            Travel Better
          </span>
        </h1>
        
        <p className="text-xl text-gray-700 mb-8 leading-relaxed">
          Expert tips, safety guides, and insider knowledge to enhance your cab riding experience. Join thousands of smart travelers.
        </p>

        <div className="flex flex-wrap gap-6 mb-8">
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 bg-green-500/20 rounded-2xl flex items-center justify-center border border-green-500/30">
              <Shield className="w-6 h-6 text-green-400" />
            </div>
            <div>
              <p className="font-semibold text-black">Safety First</p>
              <p className="text-sm text-gray-800">Verified Guides</p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 bg-blue-500/20 rounded-2xl flex items-center justify-center border border-blue-500/30">
              <DollarSign className="w-6 h-6 text-blue-400" />
            </div>
            <div>
              <p className="font-semibold text-black">Save Money</p>
              <p className="text-sm text-gray-900">Smart Tips</p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 bg-purple-500/20 rounded-2xl flex items-center justify-center border border-purple-500/30">
              <Clock4 className="w-6 h-6 text-purple-400" />
            </div>
            <div>
              <p className="font-semibold text-black">Time Saver</p>
              <p className="text-sm text-gray-900">Efficient Routes</p>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4">
          <button className="bg-black text-blue-600 px-8 py-4 rounded-2xl font-semibold hover:shadow-2xl transition-all flex items-center justify-center space-x-2 group">
            <span>Explore Articles</span>
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>
          <button className="bg-white/10 backdrop-blur-sm text-black px-8 py-4 rounded-2xl font-semibold hover:bg-white/20 transition-all border border-white/20">
            Download App
          </button>
        </div>
      </div>

      {/* RIGHT SIDE - SINGLE IMAGE ONLY */}
     <div className="relative flex justify-center lg:justify-end">
        <div className="relative max-w-md w-full">
          {/* Medium-sized image container */}
          <div className="relative rounded-2xl overflow-hidden shadow-xl border-2 border-white/30">
            <img 
              src={BlogImages}
              alt="Modern cab service"
              className="w-full h-[400px] object-cover"
            />
            
            {/* Optional subtle overlay */}
            {/* <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div> */}
          </div>
          
          {/* Optional decorative elements */}
          <div className="absolute -top-4 -right-4 w-24 h-24 bg-yellow-400/20 rounded-2xl -z-10"></div>
          <div className="absolute -bottom-4 -left-4 w-20 h-20 bg-blue-400/20 rounded-2xl -z-10"></div>
        </div>
      </div>
    </div>
  </div>
</section>

      {/* Featured Safety Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="inline-flex items-center space-x-2 bg-green-100 text-green-700 rounded-full px-4 py-2 mb-4">
              <Shield className="w-5 h-5" />
              <span className="text-sm font-semibold">SAFETY FIRST</span>
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Your Safety is Our Priority</h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Essential guides and tips to ensure every ride is safe and secure
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-8 mb-16">
            {featuredPosts.map((post, index) => (
              <article key={post.id} className="group bg-gradient-to-br from-white to-gray-50 rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-200">
                <div className="lg:flex h-full">
                  <div className="relative lg:w-2/5">
                    <img 
                      src={post.image}
                      alt={post.title}
                      // className="w-full h-64 lg:h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                    
                    <div className="absolute top-4 left-4">
                      <span className={`px-3 py-1.5 bg-gradient-to-r ${getCategoryData(post.category).color} text-white rounded-full text-xs font-semibold backdrop-blur-sm`}>
                        {getCategoryData(post.category).icon} {getCategoryData(post.category).name}
                      </span>
                    </div>
                  </div>
                  
                  <div className="lg:w-3/5 p-8 flex flex-col justify-between">
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-blue-600 transition-colors leading-tight">
                        {post.title}
                      </h3>
                      
                      <p className="text-gray-600 mb-6 leading-relaxed">
                        {post.excerpt}
                      </p>
                    </div>

                    <div>
                      <div className="flex items-center justify-between mb-4">
                        <div className="flex items-center space-x-3">
                          <img 
                            src={post.authorImage}
                            alt={post.author}
                            className="w-10 h-10 rounded-full border-2 border-white shadow-sm"
                          />
                          <div>
                            <p className="font-semibold text-gray-900">{post.author}</p>
                            <p className="text-sm text-gray-500">{post.authorRole}</p>
                          </div>
                        </div>

                        <div className="flex items-center space-x-2">
                          <button 
                            onClick={() => toggleBookmark(post.id)}
                            className={`p-2 rounded-lg transition-all ${isBookmarked[post.id] ? 'text-amber-500 bg-amber-50' : 'hover:text-amber-500 hover:bg-gray-100'}`}
                          >
                            <Bookmark className="w-5 h-5" fill={isBookmarked[post.id] ? "currentColor" : "none"} />
                          </button>
                        </div>
                      </div>

                      <div className="flex items-center justify-between text-sm text-gray-500">
                        <div className="flex items-center space-x-4">
                          <span className="flex items-center space-x-1">
                            <Calendar className="w-4 h-4" />
                            <span>{post.date}</span>
                          </span>
                          <span className="flex items-center space-x-1">
                            <Clock className="w-4 h-4" />
                            <span>{post.readTime}</span>
                          </span>
                        </div>
                        
                        <div className="flex items-center space-x-4">
                          <span className="flex items-center space-x-1">
                            <Eye className="w-4 h-4" />
                            <span>{post.views}</span>
                          </span>
                          <span className="flex items-center space-x-1">
                            <Heart className="w-4 h-4" />
                            <span>{post.likes}</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Trending Tips Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between mb-12">
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center shadow-lg">
                <TrendingUp className="w-6 h-6 text-white" />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-gray-900">Trending Tips</h2>
                <p className="text-gray-600">Most popular advice from our community</p>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {trendingPosts.map((post, index) => (
              <article key={post.id} className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 border border-gray-200 hover:border-blue-300">
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  {/* <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div> */}
                  
                  <div className="absolute top-3 left-3">
                    <div className="w-8 h-8 bg-amber-500 text-white rounded-full flex items-center justify-center font-bold text-sm shadow-lg">
                      {index + 1}
                    </div>
                  </div>

                  <div className="absolute top-3 right-3">
                    {post.premium && (
                      <span className="px-2 py-1 bg-amber-500 text-white rounded-full text-xs font-semibold backdrop-blur-sm">
                        PREMIUM
                      </span>
                    )}
                  </div>

                  <div className="absolute bottom-3 left-3">
                    <span className={`px-2 py-1 bg-gradient-to-r ${getCategoryData(post.category).color} text-white rounded-full text-xs font-semibold backdrop-blur-sm`}>
                      {getCategoryData(post.category).name}
                    </span>
                  </div>
                </div>
                
                <div className="p-6">
                  <h3 className="font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors line-clamp-2 leading-tight">
                    {post.title}
                  </h3>
                  
                  <p className="text-gray-600 text-sm mb-4 line-clamp-2 leading-relaxed">
                    {post.excerpt}
                  </p>

                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-2">
                      <img 
                        src={post.authorImage}
                        alt={post.author}
                        className="w-8 h-8 rounded-full border-2 border-white shadow-sm"
                      />
                      <span className="text-sm font-semibold text-gray-700">{post.author}</span>
                    </div>
                    
                    <div className="flex items-center space-x-3 text-xs text-gray-500">
                      <span className="flex items-center space-x-1">
                        <Eye className="w-3 h-3" />
                        <span>{post.views}</span>
                      </span>
                      <span className="flex items-center space-x-1">
                        <Heart className="w-3 h-3" />
                        <span>{post.likes}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Categories & Articles Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between mb-12">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-3">Browse Helpful Guides</h2>
              <p className="text-gray-600">Everything you need to know for a better ride experience</p>
            </div>
          </div>

          {/* Category Filters */}
          {/* <div className="flex items-center space-x-3 overflow-x-auto scrollbar-hide mb-12 pb-4">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`group flex items-center space-x-3 px-6 py-4 rounded-2xl font-semibold whitespace-nowrap transition-all duration-300 border ${
                  selectedCategory === category.id
                    ? `bg-gradient-to-r ${category.color} text-white shadow-lg scale-105 border-transparent`
                    : 'bg-white text-gray-700 hover:bg-gray-50 border-gray-200 hover:scale-105'
                }`}
              >
                <span className="text-xl">{category.icon}</span>
                <span>{category.name}</span>
                <span className={`px-2 py-1 rounded-full text-xs ${
                  selectedCategory === category.id ? 'bg-white/30' : 'bg-gray-100 text-gray-600'
                }`}>
                  {category.count}
                </span>
              </button>
            ))}
          </div> */}

          {/* Articles Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredPosts.map((post) => (
              <article key={post.id} className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 border border-gray-200 hover:border-blue-300">
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={post.image}
                    alt={post.title}
                    // className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  {/* <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div> */}
                  
                  <div className="absolute top-4 left-4">
                    <span className={`px-3 py-1.5 bg-gradient-to-r ${getCategoryData(post.category).color} text-white rounded-full text-xs font-semibold backdrop-blur-sm`}>
                      {getCategoryData(post.category).name}
                    </span>
                  </div>

                  <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="flex items-center space-x-2">
                      <button 
                        onClick={() => toggleBookmark(post.id)}
                        className={`p-2 rounded-lg backdrop-blur-sm transition-all ${isBookmarked[post.id] ? 'text-amber-500 bg-white/20' : 'text-white bg-white/10 hover:bg-white/20'}`}
                      >
                        <Bookmark className="w-4 h-4" fill={isBookmarked[post.id] ? "currentColor" : "none"} />
                      </button>
                      <button className="p-2 rounded-lg backdrop-blur-sm text-white bg-white/10 hover:bg-white/20 transition-all">
                        <Share2 className="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                </div>
                
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center space-x-2 text-sm text-gray-500">
                      <span className="flex items-center space-x-1">
                        <Calendar className="w-4 h-4" />
                        <span>{post.date}</span>
                      </span>
                      <span>•</span>
                      <span className="flex items-center space-x-1">
                        <Clock className="w-4 h-4" />
                        <span>{post.readTime}</span>
                      </span>
                    </div>
                  </div>

                  <h3 className="font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors leading-tight line-clamp-2">
                    {post.title}
                  </h3>
                  
                  <p className="text-gray-600 text-sm mb-4 leading-relaxed line-clamp-2">
                    {post.excerpt}
                  </p>

                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-2">
                      <img 
                        src={post.authorImage}
                        alt={post.author}
                        className="w-8 h-8 rounded-full border-2 border-white shadow-sm"
                      />
                      <div>
                        <p className="text-sm font-semibold text-gray-700">{post.author}</p>
                        <p className="text-xs text-gray-500">{post.authorRole}</p>
                      </div>
                    </div>
                    
                    <button className="flex items-center space-x-1 text-blue-600 font-semibold hover:text-blue-700 group/btn text-sm">
                      <span>Read</span>
                      <ArrowRight className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
                    </button>
                  </div>

                  <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-200">
                    <div className="flex items-center space-x-3 text-xs text-gray-500">
                      <span className="flex items-center space-x-1">
                        <Eye className="w-3 h-3" />
                        <span>{post.views}</span>
                      </span>
                      <span className="flex items-center space-x-1">
                        <Heart className="w-3 h-3" />
                        <span>{post.likes}</span>
                      </span>
                    </div>
                    
                    {post.premium && (
                      <span className="px-2 py-1 bg-amber-100 text-amber-700 rounded-full text-xs font-semibold">
                        PREMIUM
                      </span>
                    )}
                  </div>
                </div>
              </article>
            ))}
          </div>

          {filteredPosts.length === 0 && (
            <div className="text-center py-16">
              <div className="w-24 h-24 bg-gray-100 rounded-3xl flex items-center justify-center mx-auto mb-6">
                <Search className="w-10 h-10 text-gray-400" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">No articles found</h3>
              <p className="text-gray-600 max-w-md mx-auto mb-6">
                We couldn't find any articles matching your current selection. Try choosing a different category.
              </p>
              <button 
                onClick={() => setSelectedCategory('all')}
                className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-8 py-3 rounded-2xl font-semibold hover:shadow-lg transition-all"
              >
                Browse All Articles
              </button>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      

      
    </div>
  );
};

export default BlogPage;